<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import ToastHost from '@/components/ToastHost.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
import ResultModal from '@/components/ResultModal.vue'

const auth = useAuthStore()
</script>

<template>
  <div v-if="!auth.isInitialized" class="empty-state">読み込み中…</div>

  <!-- ログインに失敗した場合(審査Webの権限が無い等)。自動でログイン画面へ戻すと無限ループになるため、ここで止める -->
  <div v-else-if="auth.authError" class="empty-state" style="height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;text-align:center;padding:0 16px;">
    <div style="font-size:18px;font-weight:700;">セルモン商品審査</div>
    <div style="font-size:15px;font-weight:700;color:var(--ng);">{{ auth.authError.kind === 'noAccess' ? '利用権限がありません' : 'ログインできませんでした' }}</div>
    <div style="color:var(--ink-soft);font-size:13px;line-height:1.7;max-width:460px;">
      {{ auth.authError.message }}
      <template v-if="auth.authError.kind === 'noAccess'"><br />利用する場合は、管理者に「ユーザ管理」から権限の付与を依頼してください。</template>
    </div>
    <button class="btn btn-primary btn-sm" @click="auth.switchAccount()">別のアカウントでログイン</button>
  </div>

  <div v-else-if="!auth.isAuthenticated" class="empty-state" style="height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;">
    <div style="font-size:18px;font-weight:700;">セルモン商品審査</div>
    <div style="display:flex;align-items:center;gap:8px;color:var(--ink-soft);font-size:13px;">
      <span class="spinner"></span>
      ログイン画面へ移動しています…
    </div>
    <!-- 自動遷移がブロックされた場合等の保険として、手動リンクも残す -->
    <button class="btn btn-ghost btn-sm" @click="auth.login()">自動で移動しない場合はこちら</button>
  </div>

  <!-- 認証済み: ルーティングされた画面(審査Web / セルモン商品編集)を表示。
       トースト・確認モーダル・結果モーダルは全画面共通のグローバルオーバーレイなので
       ここに1つだけ置く(各Viewでは重複させない)。 -->
  <template v-else>
    <router-view />
    <ToastHost />
    <ConfirmModal />
    <ResultModal />
  </template>
</template>
